import { Injectable } from '@angular/core';

@Injectable()
export class CategoriesService {

  private menus: Array<any>;
  constructor() { }

  public getAllCategories(): Array<any> {
    this.menus = [
      {
        title : 'All',
        link : '/apicloud/discoverApi/all',
        default: true
      }
    ];
    return this.menus;
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/categories.service.ts